const SkillTag = ({text}) =>{
    return(
        <div className="flex flex-nowrap items-center mx-1 bg-white/5 outline outline-1 outline-white/20 p-2 text-xs backdrop-blur-sm rounded-lg">
            {text}
        </div>
    )
}

export default SkillTag;
